
import { z } from "zod";

export const PandadocDocumentHistoryFieldValues = ["status", "sentAt", "lastViewedAt"] as const;
export const PandadocDocumentHistoryFieldSchema = /* @__PURE__ */ z.enum(PandadocDocumentHistoryFieldValues);
export const PandadocDocumentHistoryField: (typeof PandadocDocumentHistoryFieldSchema)["enum"] = { "status": "status", "sentAt": "sentAt", "lastViewedAt": "lastViewedAt" };
export type PandadocDocumentHistoryField = (typeof PandadocDocumentHistoryFieldValues)[number];
